/*
*
* File JS per l'Archivio Magazine
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import archiveFilters from 'components/archive-filters/archive-filters';

import heroImage from 'imComponents/hero-image/hero-image';

import cardMagazine from 'components/card-magazine/card-magazine';

import pagination from 'components/pagination/pagination';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-magazine.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

archiveFilters();

//--------------------------------------------------------------------//